import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Logo from '../components/Logo';

const MentionsLegales = () => {
  return (
    <div className="min-h-screen bg-slate-50/50">
      {/* Header */}
      <header className="bg-white border-b border-slate-100 px-4 sm:px-6 lg:px-8 py-4">
        <div className="max-w-4xl mx-auto flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <Logo variant="full" size="h-10" />
          </Link>
          <Link to="/" className="flex items-center text-sm text-slate-600 hover:text-rose-600 transition-colors">
            <ArrowLeft className="w-4 h-4 mr-1" />
            Retour
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        <div className="bg-white rounded-xl border border-slate-100 shadow-sm p-6 sm:p-8 lg:p-10">
          <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-8" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Mentions légales
          </h1>

          <div className="space-y-6 text-slate-700">
            <section>
              <h2 className="text-lg font-semibold text-slate-900 mb-2">Éditeur du site</h2>
              <p>Elise Dugand</p>
              <p>Palavas-les-Flots, 34000</p>
              <p>
                Email : {' '}
                <a href="mailto:elisedugand.pro@gmail.com" className="text-rose-600 hover:underline">
                  elisedugand.pro@gmail.com
                </a>
              </p>
              <p>SIREN : 990 945 966 00010</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-slate-900 mb-2">Hébergement</h2>
              <p>
                La plateforme est hébergée par Emergent (
                <a href="https://emergent.sh" target="_blank" rel="noopener noreferrer" className="text-rose-600 hover:underline">
                  emergent.sh
                </a>
                ), dont les serveurs sont situés aux États-Unis. Emergent est certifié SOC 2 et ISO. 
                En l'absence de DPA disponible à ce jour, ce transfert repose sur les exceptions prévues 
                à l'article 49 du RGPD, notamment l'exécution d'un contrat auquel la personne concernée est partie.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-slate-900 mb-2">Propriété intellectuelle</h2>
              <p>
                L'ensemble du contenu de ce site est la propriété exclusive d'Elise Dugand. 
                Toute reproduction est interdite sans autorisation préalable.
              </p>
            </section>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-slate-100 bg-white py-6 mt-8">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row justify-center items-center gap-4 text-sm text-slate-500">
          <Link to="/politique-de-confidentialite" className="hover:text-rose-600 transition-colors">
            Politique de confidentialité
          </Link>
          <span className="hidden sm:inline">•</span>
          <Link to="/mentions-legales" className="hover:text-rose-600 transition-colors">
            Mentions légales
          </Link>
        </div>
      </footer>
    </div>
  );
};

export default MentionsLegales;
